import { useContext, useEffect, useState, useRef } from 'react'
import BrandPlaceHolder from '../../../assets/Images/placeholderimg.png';
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import atoms from '../../atoms';
import service from '../../../api/services';
import { calculateEyeConditions, currencySymbol, determineEyeType, findConstantLabel, formatLensValue, formatSignedDecimal, getCurrencyPlaceholder, getDropdown, isStoreKuwaitRegion, isValidProductType,mobileLenByRegion,priceTagFormatter, sumTwoNumbers, } from '../../../constants/utils';
import SearchTab from '../SearchTab';
import constant from '../../../constants/constant';
import ConfirmationModal from '../ConfirmationModal';
import { IoMdAddCircleOutline } from 'react-icons/io';
import CreateModal from '../CreateModal';
import { useToasts } from 'react-toast-notifications';
import { CiEdit } from "react-icons/ci";
import { IAdditionalProduct, SelectArrayProps, SelectedHeadingProps } from './interface';
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoIosAddCircleOutline } from "react-icons/io";
import { SalesCartTimer } from '../../../Context';
import { setShouldRefetch } from "../../../features/productList/list/shouldRefetchListSlice"
import { useDispatch } from 'react-redux';
const { Select, BarcodeSearch, Image, Input, Checkbox, AvailableBadge, TextArea, CustomImages, RadioInput, CustomSearch, Button } = atoms
const ProductCard = ({ product, onUpdateDiscount, getViewCart, setSelectedCartItems, setShowModal, setBackupEyeDetail, setAdditionalProduct, setBillingSummary, setShowContactLensModal, setSelectedProductId, setSelectedEyeType, customerInfo,setSelectedHeading,setSelectedProductType }: any) => {
    const [discountAmount, setDiscountAmount] = useState<number>(product?.discount);
    const [showProductDetail, setShowProductDetail] = useState<boolean>(false)
    const [showLensDetail, setShowLensDetail] = useState<boolean>(false)
    const [discountPercentage, setDiscountPercentage] = useState<number | null>(null);
    const [handleDeleteModal, setHandleDeleteModal] = useState<boolean>(false)
    const [removeProductId, setRemoveProductId] = useState<string>('')
    const [disAmount, setDisAmount] = useState<number>(NaN)
    const dispatch = useDispatch()
    const { addToast } = useToasts();
    const { salesCartTimer, setSalesCartTimer }: any = useContext(SalesCartTimer)

    //  For re-fetching the stock API
    const callBackToRefetchStockApi = (flag: boolean) => dispatch(setShouldRefetch(flag))
    // end

    const repeatItem = async (orderItemId: string) => {

        try {
            const response = await service.SalesCart.repeatItem(orderItemId)
            if (response.status === 200) {
                setSalesCartTimer({ isFirst: false, isStarted: !salesCartTimer.isStarted })
                localStorage.setItem('salesCartTimerPopup', '1')
                getViewCart(false)
                callBackToRefetchStockApi(true)
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const _handleEditProduct = async (selectedItem: any) => {
        const productData = {
            product_type_id: selectedItem?.other_product_data?.product_type_id,
            product_type_name: selectedItem?.other_product_data?.product_type_name,
            price: selectedItem?.other_product_data?.price,
            description: selectedItem?.other_product_data?.description,
            isAdditional: selectedItem?.is_other_product,
            name: selectedItem?.other_product_data?.lens_details?.name,
            phone: selectedItem?.other_product_data?.lens_details?.phone,
            heading:selectedItem?.other_product_data?.heading,

            // Right eye details
            r_dv_sph: selectedItem?.other_product_data?.lens_details?.r_dv_sph,
            r_dv_cyl: selectedItem?.other_product_data?.lens_details?.r_dv_cyl,
            r_dv_axis: selectedItem?.other_product_data?.lens_details?.r_dv_axis,
            r_dv_pd: selectedItem?.other_product_data?.lens_details?.r_dv_pd,
            r_dv_va: selectedItem?.other_product_data?.lens_details?.r_dv_va,
            r_nv_sph: selectedItem?.other_product_data?.lens_details?.r_nv_sph,
            r_nv_cyl: selectedItem?.other_product_data?.lens_details?.r_nv_cyl,
            r_nv_axis: selectedItem?.other_product_data?.lens_details?.r_nv_axis,
            r_nv_pd: selectedItem?.other_product_data?.lens_details?.r_nv_pd,
            r_add: selectedItem?.other_product_data?.lens_details?.r_add,

            // Left eye details
            l_dv_sph: selectedItem?.other_product_data?.lens_details?.l_dv_sph,
            l_dv_cyl: selectedItem?.other_product_data?.lens_details?.l_dv_cyl,
            l_dv_axis: selectedItem?.other_product_data?.lens_details?.l_dv_axis,
            l_dv_pd: selectedItem?.other_product_data?.lens_details?.l_dv_pd,
            l_dv_va: selectedItem?.other_product_data?.lens_details?.l_dv_va,
            l_nv_sph: selectedItem?.other_product_data?.lens_details?.l_nv_sph,
            l_nv_cyl: selectedItem?.other_product_data?.lens_details?.l_nv_cyl,
            l_nv_axis: selectedItem?.other_product_data?.lens_details?.l_nv_axis,
            l_nv_pd: selectedItem?.other_product_data?.lens_details?.l_nv_pd,
            l_add: selectedItem?.other_product_data?.lens_details?.l_add,

            isEdit: true,
            productId: selectedItem?.id,
        };

        await setSelectedHeading(selectedItem?.other_product_data?.heading)

        // Set additional product details
        await setAdditionalProduct(productData);

        // Set backup eye details
        await setBackupEyeDetail(productData);

        //set the product type
        setSelectedProductType(selectedItem?.other_product_data?.product_type_name);

        // Update state
        setSelectedProductId(selectedItem?.id);
        setSelectedEyeType(selectedItem?.other_product_data?.lens_details?.selectedEyeType);
        setShowModal(true);
        // setIsAdditionalProductEdit(true)
    };

    const removeItem = async () => {
        try {
            const response = await service.SalesCart.removeItem(removeProductId)
            if (response.status === 200) {
                setHandleDeleteModal(!handleDeleteModal)
                setSalesCartTimer({ isFirst: false, isStarted: !salesCartTimer.isStarted })
                localStorage.setItem('salesCartTimerPopup', '1')
                getViewCart(false)
                callBackToRefetchStockApi(true)
            }
        } catch (error) {
            console.log('error', error)
        }
    }
    const calculateDiscountPercentage = (amount: number, product_srp: number) => {
        let p = (amount / product_srp) * 100
        let percentage: any = p > 0 ? p : null
        setDiscountPercentage(parseFloat(percentage?.toFixed(isStoreKuwaitRegion() ? 3 : 2)));
        setDiscountAmount(parseFloat(amount?.toFixed(isStoreKuwaitRegion() ? 3 : 2)));
        // setDiscountAmount(amount);
        setDisAmount(amount)
        setBillingSummary((preV: any) => {
            return { ...preV, redemption_request: false };
        });
        onUpdateDiscount(product.id, percentage, amount);
    };
    useEffect(() => {
        let srp_price = product?.product?.product_srp || product?.other_product_data?.price
        calculateDiscountPercentage(product?.discount, srp_price)
    }, [product?.discount, product?.other_product_data?.price])

    const calculateDiscountAmount = (percentage: number, product_srp: number) => {
        let amount = (percentage / 100) * product_srp
        setDiscountAmount(parseFloat(amount?.toFixed(isStoreKuwaitRegion() ? 3 : 2)));
        setDiscountPercentage(percentage);
        setDisAmount(amount)
        setBillingSummary((preV: any) => {
            return { ...preV, redemption_request: false };
        });
        onUpdateDiscount(product.id, percentage, amount);
    };
    const _handleRemove = (productId: string) => {
        setHandleDeleteModal(!handleDeleteModal)
        setRemoveProductId(productId)

    }
    const _handleBarcode = (barcode: any) => {
        product.inventory_item = barcode
        setSelectedCartItems((prevArray: any) =>
            prevArray?.map((obj: any) =>
                (obj.isDelivered == true && obj.cart_item_id === product.id)
                    ? { ...obj, inventory_item_id: barcode?.value }
                    : obj
            )
        )
    }
    const _handleIsDelivered = (e: any) => {
        let isChecked = e.target.checked
        setSelectedCartItems((prevArray: any) => {
            // To unselect the barcode when this check is unChecked, 
            // use the logic below: { ...obj, inventory_item_id: isChecked ? obj.inventory_item_id : '', isDelivered: isChecked }
            const newArray = prevArray?.map((obj: any) =>
                obj.cart_item_id === product.id
                    ? { ...obj, isDelivered: isChecked }
                    : obj
                    // ? { ...obj, inventory_item_id: isChecked ? obj.inventory_item_id : '', isDelivered: isChecked }
            )

            return newArray;
        }
        )
        if (product.id) {
            product.isDelivered = isChecked;
            // product.inventory_item_id = isChecked ? product.inventory_item_id : '';
        }
    }
    useEffect(() => {
        let x = ((product?.product?.barcodes.length > 1) && (!product?.inventory_item))
            ? null // If there are multiple barcodes, don't prefill
            : {
                key: product?.inventory_item?.id || product?.inventory_item?.key || product?.product?.barcodes[0]?.id,
                value: product?.inventory_item?.id || product?.inventory_item?.value || product?.product?.barcodes[0]?.id,
                label: product?.inventory_item?.bar_code || product?.inventory_item?.label || product?.product?.barcodes[0]?.bar_code
            }
        _handleBarcode(x)
    }, [product.isDelivered])

    const handleProductClick = () => {
        setSelectedProductId(product?.id);
        setSelectedEyeType('');
        setShowContactLensModal(true);
        setShowModal(true);
        setAdditionalProduct({
            product_type_id: '',
            price: '',
            description: '',
            isAdditional: true,
            name: customerInfo?.name || '',
            phone: customerInfo?.mobile || '',
            r_dv_sph: "",
            r_dv_cyl: "",
            r_dv_axis: "",
            r_dv_pd: "",
            r_add: "",
            r_nv_sph: "",
            r_nv_cyl: "",
            r_nv_axis: "",
            r_nv_pd: "",
            l_dv_sph: "",
            l_dv_cyl: "",
            l_dv_axis: "",
            l_dv_pd: "",
            l_nv_sph: "",
            l_nv_cyl: "",
            l_nv_axis: "",
            l_nv_pd: "",
            l_add: "",
            isEdit: false,
            productId: ''
        });
        setBackupEyeDetail({
            product_type_id: '',
            price: '',
            description: '',
            isAdditional: true,
            name: customerInfo?.name || '',
            phone: customerInfo?.mobile || '',
            r_dv_sph: "",
            r_dv_cyl: "",
            r_dv_axis: "",
            r_dv_pd: "",
            r_add: "",
            r_nv_sph: "",
            r_nv_cyl: "",
            r_nv_axis: "",
            r_nv_pd: "",
            l_dv_sph: "",
            l_dv_cyl: "",
            l_dv_axis: "",
            l_dv_pd: "",
            l_nv_sph: "",
            l_nv_cyl: "",
            l_nv_axis: "",
            l_nv_pd: "",
            l_add: "",
            isEdit: false,
            productId: ''
        });
    };
    return (
        <>
            {(!product.is_other_product) ?
                // ================== For Regular Products================

                <div className='checkout-product-card mt-md-4 mt-2'>
                    <div className='d-flex flex-wrap  align-items-center justify-content-between  gap-2 '>
                        <div className='d-none d-md-flex flex-wrap gap-3 align-items-center'>

                            <div className='d-flex flex-wrap align-items-center gap-3'>
                                <h2 className='mb-0 fs-14 fw-600'>Product ID :-</h2>
                                <div className='id-input-design d-flex justify-content-between align-items-center gap-2'>
                                    <h2 className='mb-0 fs-12 fw-400'>{product?.product?.product_id_display}</h2>
                                    <Image src={'Copy'} alt="" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                        <div className='d-md-none d-flex justify-content-between w-100 align-items-center'>
                            <div>
                                <h2 className='mb-0 fs-16 fw-600'>{product?.product?.brand?.brand_name}</h2>
                            </div>
                            <div className='d-flex gap-2 text-sm-start text-md-start text-lg-end mt-1 mt-md-0 align-items-center'>
                                {(discountAmount > 0 || (discountPercentage || 0) > 0) && <p className='mb-0 fs-md-16 fs-12 fw-500 dark-gray text-decoration-line-through'>{currencySymbol()}{" "}{product?.product?.product_srp}</p>}
                                <p className='mb-0 fs-md-18 fs-14 fw-600 dark-gray'>{disAmount > 0 ? priceTagFormatter((product?.product?.product_srp - disAmount)) : priceTagFormatter(product?.product?.product_srp)}</p>
                            </div>
                        </div>
                        <div>
                            {product.availableAtStore && <div className='d-flex flex-wrap align-items-center gap-3'>
                                <Checkbox className='checkbox-style cursor-pointer'
                                    onChange={(e) => _handleIsDelivered(e)}
                                    id={'idDelivered'}
                                    label={'Product Is Delivered'}
                                    checked={product?.isDelivered}
                                    labelClass='fs-md-16 fs-12 ms-2'
                                    name={'idDelivered'} />
                            </div>}
                        </div>
                        <div className={`d-flex justify-content-between  gap-sm-4 ${product.availableAtStore && 'button-position'}`}>
                            <div className='d-none d-md-flex flex-wrap align-items-center gap-3'>
                                {(product?.product?.is_contact_lens && !product?.other_product_data) &&
                                    <h2 className='mb-0 fs-md-14 fs-10 fw-500 text-decoration-underline cursor-pointer'
                                        onClick={() => handleProductClick()}
                                    >Add Prescription</h2>}
                                {(product?.product?.is_contact_lens && product?.other_product_data) && <h2 className='mb-0 fs-md-14 fs-10 fw-500 text-decoration-underline cursor-pointer' onClick={() => { _handleEditProduct(product); setShowContactLensModal(true); }}>Edit Prescription</h2>}
                                <h2 className='mb-0 fs-md-14 fs-12 fw-500 text-decoration-underline cursor-pointer' onClick={() => _handleRemove(product?.id)}>Remove</h2>
                                <h2 className='mb-0 fs-md-14 fs-12 fw-500 text-decoration-underline cursor-pointer' onClick={() => repeatItem(product?.id)}>Repeat</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        {product.availableAtStore && <div className="sales-card-badge">
                            <AvailableBadge />
                        </div>}
                        <div className={`col-5 col-md-3 ${product.availableAtStore && "mt-3"} pe-0 mt-md-4`} style={{ overflow: "hidden" }}>
                            <div className='sales-product-image' style={{ overflow: "hidden" }}>
                                <div className=''>
                                    <CustomImages imageHeight='100px' src={product?.product?.images[0] || BrandPlaceHolder} />
                                </div>
                                <div className='d-md-none row'>
                                    <div className='col-6 d-flex justify-content-center border p-1' onClick={() => _handleRemove(product?.id)}>
                                        <RiDeleteBin6Line className='fs-18' style={{ color: "#fb3f3fe6" }} />
                                    </div>
                                    <div className='col-6 d-flex justify-content-center border p-1' onClick={() => repeatItem(product?.id)}>
                                        <IoIosAddCircleOutline className='fs-18' />
                                    </div>
                                </div>
                            </div>
                            {/* <div style={{ backgroundImage: `url(${product?.product?.images[0] || BrandPlaceHolder})` }}
                                className='img-fluid product-image ' ></div> */}
                        </div>

                        <div className={`col-7 col-md-9 ${product.availableAtStore && "mt-3"} mt-md-4 pe-0 pe-md-2`}>
                            <div className='d-md-none d-flex flex-wrap align-items-center gap-1'>
                                <h2 className='mb-0 fs-md-14 fs-10 fw-600'>Product ID :-</h2>
                                <h2 className='mb-0 fs-md-12 fs-10 fw-400 dark-gray'>{product?.product?.product_id_display}</h2>
                                {/* <div className='d-none id-input-design d-flex justify-content-between align-items-center gap-2'>
                                    <Image src={'Copy'} alt="" className='img-fluid' />
                                </div> */}
                            </div>
                            <div className='d-md-none mt-2'>
                                {<div>
                                    <div className='d-flex gap-1 mb-1'>
                                        <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>Model {window.innerWidth < 768 ? 'No' : 'Number'}: <span className='mb-0 fs-md-14 fs-11 fw-600'>{product?.product?.modal_number}</span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>Size/Power: <span className='mb-0 fs-md-14 fs-11 fw-600'>{product?.product?.glass_size}MM</span></h2>
                                    </div>
                                    <div className='d-flex gap-1 mb-1'>
                                        <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>Warranty: <span className='mb-0 fs-md-14 fs-11 fw-600'>{findConstantLabel(constant.PRODUCT_WARRANTY, product?.product?.warranty)}</span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>Polarized: <span className='mb-0 fs-md-14 fs-11 fw-600'>{findConstantLabel(constant?.POLARIZED, product?.product?.isPolarised)}</span></h2>
                                    </div>
                                </div>}
                                {showProductDetail &&
                                    <>
                                        <div className='d-flex gap-1 mb-1'>
                                            <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>With Case: <span className='mb-0 fs-md-14 fs-11 fw-600'>{product?.product?.product_with_case ? "Yes" : "No"} </span></h2>
                                            <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>Color Code: <span className='mb-0 fs-md-14 fs-11 fw-600'>{product?.product?.brand_color_code}</span></h2>
                                        </div>
                                        <div className='d-flex gap-1 mb-1'>
                                            <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'>SKU: 
                                                <span className=''>
                                                {product?.product?.barcodes && product?.product?.barcodes?.map((item: {sku_number?: {sku_number?: string}}, index: number) => {
                                                    const sku = item?.sku_number?.sku_number;
                                                        return (
                                                            <span className='fs-md-18 fs-12 fw-400' key={index}>
                                                                {`${sku}${sku && (index < (product?.product?.barcodes?.length - 1)) ? "," : ""}`}
                                                            </span>
                                                    );
                                                })}
                                                </span>
                                            </h2>
                                        </div>
                                       
                                        <div className="gap-1 align-items-center px-0">
                                            <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'><span className=''>{product?.product?.description}</span></h2>
                                        </div>
                                    </>
                                }
                                <div className='d-md-none text-start'>
                                    <a className='fs-10' style={{ minWidth: "40px" }} onClick={() => setShowProductDetail(!showProductDetail)}>{!showProductDetail ? "see more" : "see less"}</a>
                                </div>
                            </div>
                            <div className='row d-none d-md-flex flex-wrap justify-content-between align-items-end '>
                                <div className='col-lg-10'>
                                    <h2 className='mb-0 fs-md-16 fs-14 fw-600 dark-gray'>{product?.product?.brand?.brand_name}</h2>
                                    {!product?.product?.is_contact_lens && <div className="d-flex gap-md-3 gap-2 align-items-center my-2 ">
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>Model {window.innerWidth < 768 ? 'No' : 'Number'}: <span className='mb-0 fs-md-14 fs-10 fw-600'>{product?.product?.modal_number}</span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>Warranty: <span className='mb-0 fs-md-14 fs-10 fw-600'>{findConstantLabel(constant.PRODUCT_WARRANTY, product?.product?.warranty)}</span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>Polarized: <span className='mb-0 fs-md-14 fs-10 fw-600'>{findConstantLabel(constant?.POLARIZED, product?.product?.isPolarised)}</span></h2>
                                    </div>}

                                    {!product?.product?.is_contact_lens && <div className="d-flex gap-md-3 gap-2 align-items-center mb-2">
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>Color Code: <span className='mb-0 fs-md-14 fs-10 fw-600'>{product?.product?.brand_color_code}</span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>With Case: <span className='mb-0 fs-md-14 fs-10 fw-600'>{product?.product?.product_with_case ? "Yes" : "No"} </span></h2>
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>Size/Power: <span className='mb-0 fs-md-14 fs-10 fw-600'>{product?.product?.glass_size}MM</span></h2>
                                    </div>}
                                    <div className="d-flex gap-3 align-items-center ">
                                        <h2 className='mb-0 fs-md-14 fs-12 fw-500 dark-gray'><span className=''>{product?.product?.description}</span></h2>
                                    </div>
                                    <div className="d-flex gap-3 align-items-center ">
                                        <h2 className='mb-0 fs-md-14 fs-10 fw-500 dark-gray'>
                                            <span className=''>SKU:
                                            {product?.product?.barcodes && product?.product?.barcodes?.map((item:{sku_number:{sku_number:string}}, index: number) => {
                                                return (
                                                    <span className='mb-0 fs-md-14 fs-10 fw-600'>
                                                        {`${item?.sku_number?.sku_number || ''}${(item?.sku_number && (index < (product?.product?.barcodes?.length - 1))) ? "," : ""}`}
                                                    </span>
                                                        )
                                            })}
                                            </span>
                                        </h2>
                                    </div>
                                    {(product?.other_product_data?.lens_details && product?.product?.is_contact_lens) && <div className=''>
                                        <h3 className='fs-md-14 fs-11 fw-500 dark-gray mb-0'>Name : {product?.other_product_data?.lens_details?.name}</h3>
                                        <h3 className='fs-md-14 fs-11 fw-500 dark-gray'>Phone : {product?.other_product_data?.lens_details?.phone} </h3>
                                        <div className="d-none d-md-block  card p-3 mb-2">
                                            <div className="row">
                                                {(product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE || product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) &&
                                                    <div className={`col-12 ${product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE && 'col-md-6'}`}>
                                                        <h3 className='text-center fs-16 fw-600 dark-gray'>{`Right Eye (OD)`}</h3>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray">SPH</div>
                                                            <div className="col fs-11 fw-500 dark-gray">CYL</div>
                                                            <div className="col fs-11 fw-500 dark-gray">AXIS</div>
                                                            <div className="col fs-11 fw-500 dark-gray">PD</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray" style={{paddingInline:"1px"}}>DV:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_sph}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_cyl}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_axis}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_pd}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray" style={{paddingInline:"1px"}}>NV:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_sph}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_cyl}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_axis}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_pd}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray" style={{paddingInline:"0.8px"}}>ADD:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_add}</div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                        </div>

                                                    </div>}
                                                {(product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE || product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) &&
                                                    <div className={`col-12 ${product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE && 'col-md-6'}`}
                                                        style={{ borderLeft: `${product?.other_product_data?.lens_details?.selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE && '1px solid rgba(0, 0, 0, 0.175)'}` }}>
                                                        <h3 className='text-center fs-16 fw-600 dark-gray'>{`Left Eye (OS)`}</h3>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray">SPH</div>
                                                            <div className="col fs-11 fw-500 dark-gray">CYL</div>
                                                            <div className="col fs-11 fw-500 dark-gray">AXIS</div>
                                                            <div className="col fs-11 fw-500 dark-gray">PD</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray">DV:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_sph}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_cyl}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_axis}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_pd}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray">NV:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_sph}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_cyl}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_axis}</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_pd}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col fs-11 fw-500 dark-gray">ADD:</div>
                                                            <div className="col fs-11 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_add}</div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                            <div className="col fs-11 fw-500 dark-gray"></div>
                                                        </div>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                <div className='col-lg-2 text-sm-start text-md-start text-lg-end mt-1 mt-md-0 ps-0 sales-cart-price-position'>
                                    {(discountAmount > 0 || (discountPercentage || 0) > 0) && <p className='mb-0 fs-14 fw-500 dark-gray text-decoration-line-through'>{currencySymbol()}{" "}{product?.product?.product_srp}</p>}
                                    <p className='mb-0 fs-md-16 fs-12 fw-600 dark-gray sales-cart-price-position-absolute' 
                                        style={{bottom:"1px",right:"2px"}}>
                                        {disAmount > 0 ? 
                                            priceTagFormatter(parseFloat((product?.product?.product_srp - disAmount).toFixed(isStoreKuwaitRegion() ? 3 : 2))) 
                                            : priceTagFormatter(parseFloat(product?.product?.product_srp?.toFixed(isStoreKuwaitRegion() ? 3 : 2)))
                                        }
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>


                    <hr className="mt-md-3 mt-2" style={{ border: '1px solid #22222260', }} />

                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className='d-flex flex-wrap gap-md-3 gap-2 mt-md-2 mb-3 align-items-center'>
                            <h2 className="mb-0 fs-md-18 fs-12 fw-600">Item Discount :-</h2>
                            <div className='d-flex gap-md-3 gap-1 mt-md-0 align-items-center'>
                                <div className='d-flex gap-1'>
                                    <span>{currencySymbol()}</span>
                                    <Input type="number" placeholder={getCurrencyPlaceholder()} className='roundOff-inp fs-md-12 fs-10'
                                        value={discountAmount}
                                        onChange={(e: any) => calculateDiscountPercentage(parseFloat(e.target.value), product.product.product_srp)} />
                                </div>
                                <FaArrowRightArrowLeft />
                                <div>
                                    <div className="d-flex gap-1 position-relative">
                                        <Input type="number" placeholder='Percentage%' className='roundOff-inp fs-md-12 fs-10'
                                            value={discountPercentage}
                                            onChange={(e: any) => e.target.value <= 100 && calculateDiscountAmount(parseFloat(e.target.value), product.product.product_srp)} />
                                        <span>%</span>
                                        {(discountPercentage || 0) > product?.product?.brand_allocation_details?.brand_discount &&
                                            <p style={{ minWidth: '250px', bottom: '-15px' }} className='position-absolute text-danger fs-md-12 fs-14 fw-500 mb-0'> Max discount is {product?.product?.brand_allocation_details?.brand_discount}% </p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {product.isDelivered && product.availableAtStore && <div className='d-flex flex-wrap gap-md-3 gap-2 align-items-center mt-2'>
                            <h2 className="mb-md-0 fs-md-18 fs-14 fw-600">Barcode :-</h2>

                            <Select className='sales-custom-select fs-12'
                                value={{
                                    key: product?.inventory_item?.id || product?.inventory_item?.key,
                                    value: product?.inventory_item?.id || product?.inventory_item?.value,
                                    label: product?.inventory_item?.bar_code || product?.inventory_item?.label
                                }}
                                options={getDropdown(product?.product?.barcodes, 'bar_code')}
                                onChange={(e: any) => _handleBarcode(e)}
                            />
                        </div>}
                    </div>
                </div >
                :
                // ================== For Additional Products================
                <div className='checkout-product-card mt-md-4 mt-2'>
                    <div className='d-md-none d-flex justify-content-between w-100 align-items-center mb-2'>
                        <div>
                            <h2 className='mb-0 fs-16 fw-600'>{product?.other_product_data?.product_type_name}</h2>
                        </div>
                        <div className='d-flex gap-2 text-sm-start text-md-start text-lg-end'>
                            {(discountAmount > 0 || (discountPercentage || 0) > 0) && <p className='mb-0 fs-md-16 fs-12 fw-500 dark-gray text-decoration-line-through'>{priceTagFormatter(product?.other_product_data?.price)}</p>}
                            <p className='mb-0 fs-md-18 fs-14 fw-600 dark-gray'>{disAmount > 0 ? priceTagFormatter(((product?.other_product_data?.price - disAmount))) : priceTagFormatter(parseFloat((product?.other_product_data?.price)))}</p>
                        </div>
                    </div>
                    <div className='d-flex flex-wrap  align-items-center justify-content-between gap-4 '>
                        <div className='d-flex flex-wrap gap-3 align-items-center'>
                            {product.availableAtStore && <div className='d-flex flex-wrap align-items-center gap-3'>
                                <Checkbox className='checkbox-style cursor-pointer fs-12'
                                    onChange={(e) => _handleIsDelivered(e)}
                                    id={'idDelivered'} label={'Product Is Delivered'}
                                    labelClass='fs-md-16 fs-12 ms-2'
                                    checked={product?.isDelivered}
                                    name={'idDelivered'} />
                                {/* <h2 className='mb-0 fs-14 fw-600' >Product Is Delivered</h2> */}
                            </div>}
                        </div>

                        <div className='d-none d-md-flex flex-wrap align-items-center gap-3'>
                            <h2 className='mb-0 fs-md-14 fs-12 fw-500 text-decoration-underline cursor-pointer' onClick={() => _handleEditProduct(product)}>Edit</h2>
                            <h2 className='mb-0 fs-md-14 fs-12 fw-500 text-decoration-underline cursor-pointer' onClick={() => _handleRemove(product?.id)}>Remove</h2>
                            <h2 className='mb-0 fs-md-14 fs-12 fw-500 text-decoration-underline cursor-pointer' onClick={() => repeatItem(product?.id)}>Repeat</h2>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-5 col-md-3 mt-3 pe-0 pe-md-1 mt-md-4" style={{ overflow: "hidden" }}>
                            <div style={{ overflow: "hidden" }}>
                                <div className='sales-product-image'>
                                    <Image src={BrandPlaceHolder} alt="Product Image" className='img-fluid product-image ' />
                                </div>
                                <div className='d-md-none'>
                                    <div className='d-flex'>
                                        <div className='col-4 d-flex justify-content-center border p-1' onClick={() => _handleRemove(product?.id)}>
                                            <RiDeleteBin6Line className='fs-18' style={{ color: "#fb3f3fe6" }} />
                                        </div>
                                        <div className='col-4 d-flex justify-content-center border p-1' onClick={() => _handleEditProduct(product)}>
                                            <CiEdit className='fs-18' />
                                        </div>
                                        <div className='col-4 d-flex justify-content-center border p-1' onClick={() => repeatItem(product?.id)}>
                                            <IoIosAddCircleOutline className='fs-18 fw-400' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="sales-product-image col-5 col-md-3 mt-md-4 mt-3" style={{overflow:"hidden"}}>
                            <div>
                                <Image src={BrandPlaceHolder} alt="Product Image" className='img-fluid product-image ' />
                            </div>
                        </div> */}

                        <div className="col-7 col-md-9 mt-md-4 mt-3">
                            <div className='row flex-wrap justify-content-between align-items-end '>
                                <div className="w-80">
                                    <h2 className='d-none d-md-flex mb-0 fs-md-16 fs-12 fw-600 dark-gray'>{product?.other_product_data?.product_type_name}</h2>
                                    <div className="d-flex gap-3 align-items-center mt-2">
                                        <h2 className='mb-0 fs-md-14 fs-11 fw-500 dark-gray'><span className=''>{product?.other_product_data?.description}</span></h2>
                                    </div>
                                    {product?.other_product_data?.lens_details && <div className='mt-2'>
                                        <h3 className='fs-md-14 fs-11 fw-500 dark-gray'>Name : {product?.other_product_data?.lens_details?.name}</h3>
                                        <h3 className='fs-md-14 fs-11 fw-500 dark-gray'>Phone : {product?.other_product_data?.lens_details?.phone} </h3>
                                        <div className="d-none d-md-block  card p-3 mb-2">
                                            <div className="row">
                                                <div className="col-12 col-md-6 pe-1">
                                                    <h3 className='text-center fs-16 fw-600 dark-gray'>{`Right Eye (OD)`}</h3>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                        <div className="col fs-11 fw-500 dark-gray">SPH</div>
                                                        <div className="col fs-11 fw-500 dark-gray">CYL</div>
                                                        <div className="col fs-11 fw-500 dark-gray">AXIS</div>
                                                        <div className="col fs-11 fw-500 dark-gray">PD</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray pe-0">DV:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0 lens-detail-padding-right">{product?.other_product_data?.lens_details?.r_dv_sph}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0 lens-detail-padding-right">{product?.other_product_data?.lens_details?.r_dv_cyl}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0 lens-detail-padding-right">{product?.other_product_data?.lens_details?.r_dv_axis}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0 lens-detail-padding-right">{product?.other_product_data?.lens_details?.r_dv_pd}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray pe-0">NV:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.r_nv_sph}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.r_nv_cyl}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.r_nv_axis}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.r_nv_pd}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray">ADD:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.r_add}</div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                    </div>

                                                </div>
                                                <div className="col-12 col-md-6 pe-1" style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.175)' }}>
                                                    <h3 className='text-center fs-16 fw-600 dark-gray'>{`Left Eye (OS)`}</h3>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray pe-0"></div>
                                                        <div className="col fs-11 fw-500 dark-gray">SPH</div>
                                                        <div className="col fs-11 fw-500 dark-gray">CYL</div>
                                                        <div className="col fs-11 fw-500 dark-gray">AXIS</div>
                                                        <div className="col fs-11 fw-500 dark-gray">PD</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray pe-0">DV:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_dv_sph}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_dv_cyl}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_dv_axis}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_dv_pd}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray pe-0">NV:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_nv_sph}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_nv_cyl}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_nv_axis}</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_nv_pd}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col fs-11 fw-500 dark-gray">ADD:</div>
                                                        <div className="col fs-11 fw-500 dark-gray ps-0">{product?.other_product_data?.lens_details?.l_add}</div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                        <div className="col fs-11 fw-500 dark-gray"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                <div className='d-none d-md-block text-sm-start text-md-start text-lg-end mt-3 mt-md-0'>
                                    {(discountAmount > 0 || (discountPercentage || 0) > 0) && <p className='mb-0 fs-16 fw-500 dark-gray text-decoration-line-through'>{priceTagFormatter(product?.other_product_data?.price)}</p>}
                                    <p className='mb-0 fs-md-18 fs-12 fw-600 dark-gray'>{disAmount > 0 ? priceTagFormatter(parseFloat((product?.other_product_data?.price - disAmount)?.toFixed(isStoreKuwaitRegion() ? 3 : 2))) : priceTagFormatter(parseFloat((product?.other_product_data?.price)?.toFixed(isStoreKuwaitRegion() ? 3 : 2)))}</p>
                                </div>
                            </div>
                            {product?.other_product_data?.lens_details && <div className='d-md-none text-start'>
                                <a className='fs-10' style={{ minWidth: "40px" }} onClick={() => setShowLensDetail(!showLensDetail)}>{!showLensDetail ? "see more" : "see less"}</a>
                            </div>}
                        </div>
                    </div>
                    {(product?.other_product_data?.lens_details && showLensDetail) && <div className='d-md-none mt-2'>
                        <div className="card p-3 mb-2">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <h3 className='text-center fs-16 fw-600 dark-gray'>{`Right Eye (OD)`}</h3>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray">SPH</div>
                                        <div className="col fs-12 fw-500 dark-gray">CYL</div>
                                        <div className="col fs-12 fw-500 dark-gray">AXIS</div>
                                        <div className="col fs-12 fw-500 dark-gray">PD</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">DV:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_sph}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_cyl}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_axis}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_dv_pd}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">NV:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_sph}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_cyl}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_axis}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_nv_pd}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">ADD:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.r_add}</div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                    </div>

                                </div>
                                <div className="col-12 col-md-6" style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.175)' }}>
                                    <h3 className='text-center fs-16 fw-600 dark-gray'>{`Left Eye (OS)`}</h3>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray">SPH</div>
                                        <div className="col fs-12 fw-500 dark-gray">CYL</div>
                                        <div className="col fs-12 fw-500 dark-gray">AXIS</div>
                                        <div className="col fs-12 fw-500 dark-gray">PD</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">DV:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_sph}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_cyl}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_axis}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_dv_pd}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">NV:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_sph}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_cyl}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_axis}</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_nv_pd}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-12 fw-500 dark-gray">ADD:</div>
                                        <div className="col fs-12 fw-500 dark-gray">{product?.other_product_data?.lens_details?.l_add}</div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                        <div className="col fs-12 fw-500 dark-gray"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                    <hr className="mt-3" style={{ border: '1px solid #22222260', }} />

                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className='d-flex flex-wrap gap-md-3 gap-2 mt-md-2 mb-3 align-items-center'>
                            <h2 className="mb-0 fs-md-18 fs-12 fw-600">Item Discount :-</h2>
                            <div className='d-flex gap-md-3 gap-1 mt-md-0 align-items-center'>
                                <div className='d-flex gap-1'>
                                    <span>{currencySymbol()}</span>
                                    <Input type="number" placeholder={getCurrencyPlaceholder()} className='roundOff-inp'
                                        value={discountAmount}
                                        onChange={(e: any) => calculateDiscountPercentage(parseFloat(e.target.value), product.other_product_data.price)} />
                                </div>
                                <FaArrowRightArrowLeft />
                                <div className="d-flex gap-1">
                                    <Input type="number" placeholder='Percentage%' className='roundOff-inp'
                                        value={discountPercentage}
                                        onChange={(e: any) => e.target.value <= 100 && calculateDiscountAmount(parseFloat(e.target.value), product.other_product_data.price)} />
                                    <span>%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >}
            {
                handleDeleteModal && <ConfirmationModal
                    show={handleDeleteModal}
                    handleConfirmItem={() => removeItem()}
                    onHide={() => setHandleDeleteModal(!handleDeleteModal)}
                    message={'remove this product'} />
            }
        </>
    )
}
const Index = ({ cart_Data, getViewCart, setSearchProduct, productList, setSelectedCartItems,
    setBillingSummary, customerInfo, setSearchType }: any) => {

    let cartData = cart_Data
    const inputRef = useRef<any>(null);
    const { addToast } = useToasts();
    const [isOpen, setIsOpen] = useState(false);
    const [isProduct, setIsProduct] = useState("")
    const [showModal, setShowModal] = useState<boolean>(false)
    const [showContactLensModal, setShowContactLensModal] = useState<boolean>(false)
    const [selectedProductType, setSelectedProductType] = useState<string>('')
    const [productTypeList, setProductTypeList] = useState()
    const [headingForLens, setHeadingForLens] = useState<SelectArrayProps[]>()
    const [headingForContactLens, setHeadingForContactLens] = useState<SelectArrayProps[]>()
    const [selectedProductId, setSelectedProductId] = useState('')
    const [lensDetailsError, setLensDetailsError] = useState<boolean>(false)
    const [selectedEyeType, setSelectedEyeType] = useState<any>('')
    // const [isAdditionalProductEdit,setIsAdditionalProductEdit] = useState<boolean>(false)
    const [eyeTypes, setEyeTypes] = useState([
        { label: 'Right Eye', value: 1 },
        { label: 'Left Eye', value: 2 },
        { label: 'Both Eyes', value: 3 }
    ])
    const [selectedHeading, setSelectedHeading ]= useState<SelectedHeadingProps[]| null>()
    const [additionalProduct, setAdditionalProduct] = useState<IAdditionalProduct>({
        product_type_id: '',
        price: '',
        description: '',
        isAdditional: true,
        name: customerInfo?.name || '',
        phone: customerInfo?.mobile || '',
        r_dv_sph: "",
        r_dv_cyl: "",
        r_dv_axis: "",
        r_dv_pd: "",
        r_add: "",
        r_nv_sph: "",
        r_nv_cyl: "",
        r_nv_axis: "",
        r_nv_pd: "",
        l_dv_sph: "",
        l_dv_cyl: "",
        l_dv_axis: "",
        l_dv_pd: "",
        l_nv_sph: "",
        l_nv_cyl: "",
        l_nv_axis: "",
        l_nv_pd: "",
        l_add: "",
        isEdit: false,
        productId: ''
    })
    const [backupEyeDetail, setBackupEyeDetail] = useState<IAdditionalProduct>({
        product_type_id: '',
        price: '',
        description: '',
        isAdditional: true,
        name: customerInfo?.name || '',
        phone: customerInfo?.mobile || '',
        r_dv_sph: "",
        r_dv_cyl: "",
        r_dv_axis: "",
        r_dv_pd: "",
        r_add: "",
        r_nv_sph: "",
        r_nv_cyl: "",
        r_nv_axis: "",
        r_nv_pd: "",
        l_dv_sph: "",
        l_dv_cyl: "",
        l_dv_axis: "",
        l_dv_pd: "",
        l_nv_sph: "",
        l_nv_cyl: "",
        l_nv_axis: "",
        l_nv_pd: "",
        l_add: "",
        isEdit: false,
        productId: ''
    })
    const [lensPhoneNumberError, setLensPhoneNumberError] = useState<boolean>(false)
    const [eyeTypeError, setEyeTypeError] = useState<boolean>(false)
    const { salesCartTimer, setSalesCartTimer }: any = useContext(SalesCartTimer)
    const clearFields = () => {
        // setSelectedProductId('')
        setEyeTypeError(false)
        return setAdditionalProduct({
            product_type_id: '',
            price: '',
            description: '',
            isAdditional: false,
            name: customerInfo?.name || '',
            phone: customerInfo?.mobile || '',
            r_dv_sph: "",
            r_dv_cyl: "",
            r_dv_axis: "",
            r_dv_pd: "",
            r_add: "",
            r_nv_sph: "",
            r_nv_cyl: "",
            r_nv_axis: "",
            r_nv_pd: "",
            l_dv_sph: "",
            l_dv_cyl: "",
            l_dv_axis: "",
            l_dv_pd: "",
            l_nv_sph: "",
            l_nv_cyl: "",
            l_nv_axis: "",
            l_nv_pd: "",
            l_add: "",
        })
    }
    const addItem = async (productId: { id: string,inventory_item_id:string }) => {
        const payload = cartData?.searchType === 'search'
        ? { product_id: productId?.id }
        : {
            product_id: productId?.id,
            inventory_item_id: productId?.inventory_item_id,
          };
      
        try {
           const response =  await service.SalesCart.addToCart(payload)
           if(response?.status === 200 || response?.status === 201){
               setSalesCartTimer({ isFirst: false, isStarted: !salesCartTimer.isStarted })
               localStorage.setItem('salesCartTimerPopup', '1')
               getViewCart(false)
           }
        } catch (error: any) {
            console.log('error', error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const searchCallBack = (search: string) => {
        setIsProduct(search)
        setSearchProduct(search)
        setIsOpen(cartData?.searchType === 'search' ? true :  false)
    }
    const clearSearchField = () => {
        if (inputRef?.current) {
            inputRef.current.value = '';
        }
    };

    const updateDiscount = (productId: number, discountPercentage: number, discountAmount: number) => {
        setSelectedCartItems((prevArray: any) =>
            prevArray?.map((obj: any) =>
                obj.cart_item_id === productId
                    ? { ...obj, discount: discountAmount }
                    : obj
            )
        )
    };

    const getDropdownAdditionalProductHeading = (response: []) => {
        let dropdown: any = []
        response && response.map((value: any) => {
            dropdown.push({
                "key": value.id,
                "value": value.id,
                "label": value.lens_data.heading,
                "amount":value.lens_data.amount,
                "description":value.lens_data?.description,
                "lens_cost":value.lens_data?.lens_cost
            }
            )
        })
        return dropdown
    }

    const getHeadingForAdditionalProduct = async () => {
        try {
            let response = await service.Product.lensDetails()
            if (response.status === 200) {
                const forLens = response.data.data?.filter((item: any) => (item?.product_type?.name)?.toLowerCase() === "lens")
                const forContactLens = response.data.data?.filter((item: any) => (item?.product_type?.name)?.toLowerCase() === 'contact lens' )
                setHeadingForLens(getDropdownAdditionalProductHeading(forLens))
                setHeadingForContactLens(getDropdownAdditionalProductHeading(forContactLens))
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const getProductTypeList = async () => {
        try {
            let response = await service.Product.productTypeList()
            if (response.status === 200) {
                // response.data.data = response?.data?.data?.filter((item: any) => (item?.name)?.toLowerCase() !== Contact_lens)
                setProductTypeList(getDropdown(response.data.data, 'name'))
            }
        } catch (error) {
            console.log('error', error)
        }
    }
    const _handleSelectedProductType = (obj: any, isEyeType: any = false) => {
        setSelectedHeading(null)
        setAdditionalProduct({
            product_type_id: isEyeType ? '' : obj.value,
            price: '',
            description: '',
            isAdditional: false,
            name: customerInfo?.name || '',
            phone: customerInfo?.mobile || '',
            r_dv_sph: "",
            r_dv_cyl: "",
            r_dv_axis: "",
            r_dv_pd: "",
            r_add: "",
            r_nv_sph: "",
            r_nv_cyl: "",
            r_nv_axis: "",
            r_nv_pd: "",
            l_dv_sph: "",
            l_dv_cyl: "",
            l_dv_axis: "",
            l_dv_pd: "",
            l_nv_sph: "",
            l_nv_cyl: "",
            l_nv_axis: "",
            l_nv_pd: "",
            l_add: "",
        });
        if (isEyeType) {
            // clearFields()
            setSelectedEyeType(obj)
        } else {
            setSelectedProductType(obj.label)
        }
        setLensPhoneNumberError(false)
    }

    // for select the heading
    const _handleSelectedHeading = (obj: any) => {
        setSelectedHeading(obj)
        setAdditionalProduct({
            ...additionalProduct,
            price: obj.amount,
            description: obj.description,
        });
    }
    // end

    const _handleSelectedEyeType = (obj: any) => {
        let tempEyeDetail = additionalProduct
        if (obj && obj.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
            if (
                !(tempEyeDetail.r_dv_sph === tempEyeDetail.l_dv_sph &&
                    tempEyeDetail.r_dv_cyl === tempEyeDetail.l_dv_cyl &&
                    tempEyeDetail.r_dv_axis === tempEyeDetail.l_dv_axis &&
                    tempEyeDetail.r_dv_pd === tempEyeDetail.l_dv_pd &&
                    tempEyeDetail.r_add === tempEyeDetail.l_add &&
                    tempEyeDetail.r_nv_sph === tempEyeDetail.l_nv_sph &&
                    tempEyeDetail.r_nv_cyl === tempEyeDetail.l_nv_cyl &&
                    tempEyeDetail.r_nv_axis === tempEyeDetail.l_nv_axis &&
                    tempEyeDetail.r_nv_pd === tempEyeDetail.l_nv_pd)
            ) {
                setAdditionalProduct({

                    product_type_id: '',
                    price: '',
                    description: '',
                    isAdditional: false,
                    name: additionalProduct?.name || '',
                    phone: additionalProduct?.phone || '',
                    r_dv_sph: "",
                    r_dv_cyl: "",
                    r_dv_axis: "",
                    r_dv_pd: "",
                    r_add: "",
                    r_nv_sph: "",
                    r_nv_cyl: "",
                    r_nv_axis: "",
                    r_nv_pd: "",
                    l_dv_sph: "",
                    l_dv_cyl: "",
                    l_dv_axis: "",
                    l_dv_pd: "",
                    l_nv_sph: "",
                    l_nv_cyl: "",
                    l_nv_axis: "",
                    l_nv_pd: "",
                    l_add: "",
                });
            }
        } else {
            let tempBackupDetail = { ...backupEyeDetail };
            tempBackupDetail.name = additionalProduct?.name || '';
            tempBackupDetail.phone = additionalProduct?.phone || '';
            setAdditionalProduct(tempBackupDetail);

        }
        setSelectedEyeType(obj)
        setLensPhoneNumberError(false)
    }

    const formatValue = (value: number, targetValue: string) => {
        return value !== undefined ? ((/\+/.test(targetValue)) ? `+${value}` : `${value}`) : '';
    }

    const handleSubmit = async () => {
        const payload: any = {
            product_type_id: additionalProduct?.product_type_id,
            price: additionalProduct?.price,
            description: additionalProduct?.description,
            isAdditional: true,
            heading:selectedHeading,
            lens_details: (isValidProductType(selectedProductType) || isValidProductType(additionalProduct?.product_type_name) || showContactLensModal) ?
                {
                    name: additionalProduct?.name,
                    phone: additionalProduct?.phone,

                    r_dv_sph: `${formatSignedDecimal(additionalProduct?.r_dv_sph)}`,
                    r_dv_cyl: `${formatSignedDecimal(additionalProduct?.r_dv_cyl)}`,
                    r_dv_axis: `${formatSignedDecimal(additionalProduct?.r_dv_axis)}`,
                    r_dv_pd: `${formatSignedDecimal(additionalProduct?.r_dv_pd)}`,
                    r_add: `${formatSignedDecimal(additionalProduct?.r_add)}`,

                    r_nv_sph: `${formatSignedDecimal(additionalProduct?.r_nv_sph)}`,
                    r_nv_cyl: `${formatSignedDecimal(additionalProduct?.r_nv_cyl)}`,
                    r_nv_axis: `${formatSignedDecimal(additionalProduct?.r_nv_axis)}`,
                    r_nv_pd: `${formatSignedDecimal(additionalProduct?.r_nv_pd)}`,

                    l_dv_sph: `${formatSignedDecimal(additionalProduct?.l_dv_sph)}`,
                    l_dv_cyl: `${formatSignedDecimal(additionalProduct?.l_dv_cyl)}`,
                    l_dv_axis: `${formatSignedDecimal(additionalProduct?.l_dv_axis)}`,
                    l_dv_pd: `${formatSignedDecimal(additionalProduct?.l_dv_pd)}`,
                    l_nv_sph: `${formatSignedDecimal(additionalProduct?.l_nv_sph)}`,
                    l_nv_cyl: `${formatSignedDecimal(additionalProduct?.l_nv_cyl)}`,
                    l_nv_axis: `${formatSignedDecimal(additionalProduct?.l_nv_axis)}`,
                    l_nv_pd: `${formatSignedDecimal(additionalProduct?.l_nv_pd)}`,
                    l_add: `${formatSignedDecimal(additionalProduct?.l_add)}`,

                }
                : null
        }
        if (showContactLensModal) {
            payload.product_type_id = ''
            payload.price = ''
            payload.description = ''
            payload.isAdditional = false
            payload.itemId = selectedProductId
            payload.lens_details.selectedEyeType = selectedEyeType
        }
        let response
        try {
            if ((isValidProductType(selectedProductType) || isValidProductType(additionalProduct?.product_type_name))
                && (additionalProduct?.name.length <= 0 || additionalProduct?.phone == null) || showContactLensModal && (additionalProduct?.name.length <= 0 || additionalProduct?.phone == null || !selectedEyeType)) {
                setLensDetailsError(true)

            } else {
                setLensDetailsError(false)
                if (showContactLensModal) {
                    response = await service.SalesCart.updateLensDetail(selectedProductId, payload)
                } else {

                    if (additionalProduct.isEdit) {
                        response = await service.SalesCart.EditItem(additionalProduct?.productId || '', payload)

                    } else {
                        response = await service.SalesCart.addAdditionalProducts(payload)

                    }
                }
                if (response.status === 200) {
                    setSalesCartTimer({ isFirst: false, isStarted: !salesCartTimer.isStarted })
                    localStorage.setItem('salesCartTimerPopup', '1')
                    getViewCart(false)
                    setShowModal(false)
                    setShowContactLensModal(false)
                    setSelectedProductType('')
                    setSelectedEyeType('')
                    clearFields()
                }
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    const _handleOnHide = () => {
        setShowModal(false)
        setSelectedEyeType('')
        setShowContactLensModal(false)
        setSelectedProductType('')
        clearFields()
    }

    // const calculateEyeConditions = (tempEyeDetail: any) => {
    //     const {
    //         r_dv_sph,
    //         r_dv_cyl,
    //         r_dv_axis,
    //         r_dv_pd,
    //         r_add,
    //         r_nv_sph,
    //         r_nv_cyl,
    //         r_nv_axis,
    //         r_nv_pd,
    //         l_dv_sph,
    //         l_dv_cyl,
    //         l_dv_axis,
    //         l_dv_pd,
    //         l_add,
    //         l_nv_sph,
    //         l_nv_cyl,
    //         l_nv_axis,
    //         l_nv_pd,
    //     } = tempEyeDetail;

    //     const isRightEmpty = Boolean(
    //         r_dv_sph || r_dv_cyl || r_dv_axis || r_dv_pd || r_add ||
    //         r_nv_sph || r_nv_cyl || r_nv_axis || r_nv_pd
    //     );

    //     const isLeftEmpty = Boolean(
    //         l_dv_sph || l_dv_cyl || l_dv_axis || l_dv_pd || l_add ||
    //         l_nv_sph || l_nv_cyl || l_nv_axis || l_nv_pd
    //     );

    //     const isBothEqual =
    //         r_dv_sph === l_dv_sph &&
    //         r_dv_cyl === l_dv_cyl &&
    //         r_dv_axis === l_dv_axis &&
    //         r_dv_pd === l_dv_pd &&
    //         r_add === l_add &&
    //         r_nv_sph === l_nv_sph &&
    //         r_nv_cyl === l_nv_cyl &&
    //         r_nv_axis === l_nv_axis &&
    //         r_nv_pd === l_nv_pd;

    //     return { isRightEmpty, isLeftEmpty, isBothEqual };
    // };
    // const determineEyeType = (tempEyeDetail: any) => {
    //     const { isRightEmpty, isLeftEmpty, isBothEqual } = calculateEyeConditions(tempEyeDetail);

    //     if (isBothEqual) {
    //         return { label: 'Both Eyes', value: constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE };
    //     } else if (isRightEmpty && !isLeftEmpty) {
    //         return { label: 'Right Eyes', value: constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE };
    //     } else if (!isRightEmpty && isLeftEmpty) {
    //         return { label: 'Left Eyes', value: constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE };
    //     } else if (!isRightEmpty && !isLeftEmpty) {
    //         return { label: 'Both Eyes', value: constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE };
    //     } else if (isRightEmpty && isLeftEmpty) {
    //         return { label: 'Left Eyes', value: constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE };
    //     }
    // };

    const getLensContactLensDetail = async (phoneNumber: number, selectedProductType: string) => {
        try {
            setLensPhoneNumberError(true)
            if (phoneNumber?.toString()?.length === mobileLenByRegion()) {
                const response = await service?.Prescription?.searchPrescription({ search: phoneNumber })
                let type = showContactLensModal ? 'contact_lens' : selectedProductType.toLowerCase()?.replace(/\s/g, '_')
                if (response.status === 200) {
                    let lensDetail = response?.data?.data?.[type]?.prescription_details
                    if (showContactLensModal) {
                        const eyeType = selectedEyeType || determineEyeType(lensDetail);
                        const getEyeValues = (details: any) => ({
                            r_dv_sph: formatLensValue(details?.r_dv_sph) || '',
                            r_dv_cyl: formatLensValue(details?.r_dv_cyl) || '',
                            r_dv_axis: formatLensValue(details?.r_dv_axis) || '',
                            r_dv_pd: formatLensValue(details?.r_dv_pd) || '',
                            r_add: formatLensValue(details?.r_add) || '',
                            r_nv_sph: formatLensValue(details?.r_nv_sph) || '',
                            r_nv_cyl: formatLensValue(details?.r_nv_cyl) || '',
                            r_nv_axis: formatLensValue(details?.r_nv_axis) || '',
                            r_nv_pd: formatLensValue(details?.r_nv_pd) || '',
                            l_dv_sph: formatLensValue(details?.l_dv_sph) || '',
                            l_dv_cyl: formatLensValue(details?.l_dv_cyl) || '',
                            l_dv_axis: formatLensValue(details?.l_dv_axis) || '',
                            l_dv_pd: formatLensValue(details?.l_dv_pd) || '',
                            l_nv_sph: formatLensValue(details?.l_nv_sph) || '',
                            l_nv_cyl: formatLensValue(details?.l_nv_cyl) || '',
                            l_nv_axis: formatLensValue(details?.l_nv_axis) || '',
                            l_nv_pd: formatLensValue(details?.l_nv_pd) || '',
                            l_add: formatLensValue(details?.l_add) || '',
                        });
                        const commonValues = {
                            name: lensDetail?.name || '',
                        };
                        setSelectedEyeType(eyeType);
                        const eyeValues = selectedEyeType
                            ? (selectedEyeType.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE && !calculateEyeConditions(lensDetail)?.isBothEqual
                                ? getEyeValues({})
                                : getEyeValues(lensDetail))
                            : getEyeValues(lensDetail);

                        setAdditionalProduct({
                            ...additionalProduct,
                            ...commonValues,
                            ...eyeValues,
                        });
                        setBackupEyeDetail({
                            ...backupEyeDetail,
                            ...commonValues,
                            phone: lensDetail?.phone || '',
                            ...getEyeValues(lensDetail),
                        });
                    }
                    else {
                        setAdditionalProduct({
                            ...additionalProduct,
                            name: lensDetail?.name || '',
                            r_dv_sph: formatLensValue(lensDetail?.r_dv_sph) || '',
                            r_dv_cyl: formatLensValue(lensDetail?.r_dv_cyl) || '',
                            r_dv_axis: formatLensValue(lensDetail?.r_dv_axis) || "",
                            r_dv_pd: formatLensValue(lensDetail?.r_dv_pd) || '',
                            r_add: formatLensValue(lensDetail?.r_add) || '',
                            r_nv_sph: formatLensValue(lensDetail?.r_nv_sph) || '',
                            r_nv_cyl: formatLensValue(lensDetail?.r_nv_cyl) || '',
                            r_nv_axis: formatLensValue(lensDetail?.r_nv_axis) || '',
                            r_nv_pd: formatLensValue(lensDetail?.r_nv_pd) || '',
                            l_dv_sph: formatLensValue(lensDetail?.l_dv_sph) || '',
                            l_dv_cyl: formatLensValue(lensDetail?.l_dv_cyl) || '',
                            l_dv_axis: formatLensValue(lensDetail?.l_dv_axis) || '',
                            l_dv_pd: formatLensValue(lensDetail?.l_dv_pd) || '',
                            l_nv_sph: formatLensValue(lensDetail?.l_nv_sph) || '',
                            l_nv_cyl: formatLensValue(lensDetail?.l_nv_cyl) || '',
                            l_nv_axis: formatLensValue(lensDetail?.l_nv_axis) || '',
                            l_nv_pd: formatLensValue(lensDetail?.l_nv_pd) || '',
                            l_add: formatLensValue(lensDetail?.l_add) || '',
                        })
                    }

                }
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    // function to show the heading inputfield in additional popup
    const showLensHeading=():boolean=>{
        const productTypeLowerCase = selectedProductType.toLowerCase() || additionalProduct?.product_type_name?.toLocaleLowerCase();
        return  (
            (productTypeLowerCase === 'lens' || productTypeLowerCase === 'contact lens' )
        )
    }
    // end

    // function to get option for the heading inputfield in additional popup
    const optionForLensHeading=():SelectArrayProps[] | undefined=>{
        const productTypeLowerCase = selectedProductType.toLowerCase() || additionalProduct?.product_type_name?.toLocaleLowerCase();
        return  (
            productTypeLowerCase === 'lens' ? headingForLens : headingForContactLens
        )
    }
    // end



    useEffect(() => {
        getProductTypeList()
        getHeadingForAdditionalProduct()
    }, [])

    const clearEyeDetail = () => {
        const clearFields = (fields: any) => {
            return fields.reduce((acc: any, field: string) => {
                acc[field] = '';
                return acc;
            }, {});
        };

        const leftEyeFields = [
            'l_dv_sph', 'l_dv_cyl', 'l_dv_axis', 'l_dv_pd',
            'l_nv_sph', 'l_nv_cyl', 'l_nv_axis', 'l_nv_pd', 'l_add'
        ];

        const rightEyeFields = [
            'r_dv_sph', 'r_dv_cyl', 'r_dv_axis', 'r_dv_pd',
            'r_nv_sph', 'r_nv_cyl', 'r_nv_axis', 'r_nv_pd', 'r_add'
        ];

        let clearedFields = {};

        if (selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE) {
            clearedFields = clearFields(leftEyeFields);
        } else if (selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE) {
            clearedFields = clearFields(rightEyeFields);
        } else if (selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
            clearedFields = {
                ...clearFields(leftEyeFields),
                ...clearFields(rightEyeFields)
            };
        }

        setAdditionalProduct({
            ...additionalProduct,
            ...clearedFields
        });

        setBackupEyeDetail({
            ...additionalProduct,
            ...clearedFields
        });
    };
    return (
        <div className='sales-checkout-card'>
            <div className="d-md-flex">
                <h2 className='mb-0 fs-16 fw-600 align-items-center'>Cart ({cartData?.cart_items?.length} items)</h2>
                <div className='d-flex mt-md-0 mt-1 align-items-center'>
                    <RadioInput type="radio" name='search_type'
                        className="ms-sm-2"
                        onChange={(e: any) => { setSearchType('barcode'), clearSearchField(); searchCallBack("") }}
                        checked={cartData?.searchType === 'barcode'}
                        labelClass='fs-md-16 fs-14'
                        value={'barcode'} label='Barcode' id={'Yes'}
                    />
                    <RadioInput type="radio" name='search_type'
                        className="ms-2"
                        labelClass='fs-md-16 fs-14'
                        onChange={(e: any) => { setSearchType('search'); clearSearchField(); searchCallBack("") }}
                        checked={cartData?.searchType === 'search'}
                        value={'search'} label={`Product Id / Modal ${window.innerWidth < 768 ? 'No.' : 'Number'}`} id={'No'}
                    />
                </div>
            </div>
            <div className='mt-sm-4 mt-2 position-relative' onClick={() => setIsOpen(cartData?.searchType === 'search' ? !isOpen : false)}>
                <BarcodeSearch placeholder={cartData?.searchType === 'search' ? 'Enter Product ID Or Modal Number' : 'Enter Barcode'}
                    searchCallBack={(value:string)=>searchCallBack(value)}
                    className='fs-md-16 fs-12 new-custom-search sales-input-height' 
                    searchValueLength={cartData?.searchType === 'search' ? 1 : 6}
                    isClearable={cartData?.searchType === 'search' ? false : true}
                    />
                {(isProduct.length > 0 && isOpen) && <SearchTab data={productList} searchCallBack={addItem} />}
            </div>

            <div className="col-12 mt-sm-4 mt-2 other-items-btn"
                onClick={() => {
                    setShowModal(true);
                    // setIsAdditionalProductEdit(false)
                    }}>
                Add Additional Products
                <IoMdAddCircleOutline className='fs-22 ms-1' />
            </div>

            {cartData && cartData?.cart_items?.map((item: any, index: number) => {
                return (
                    <ProductCard key={item.id} product={item} onUpdateDiscount={updateDiscount}
                        getViewCart={getViewCart} setSelectedCartItems={setSelectedCartItems} setShowModal={setShowModal}
                        setShowContactLensModal={setShowContactLensModal} setSelectedProductId={setSelectedProductId}
                        setSelectedEyeType={setSelectedEyeType}
                        setAdditionalProduct={setAdditionalProduct}
                        setBackupEyeDetail={setBackupEyeDetail}
                        setBillingSummary={setBillingSummary} customerInfo={customerInfo} 
                        // setIsAdditionalProductEdit={setIsAdditionalProductEdit}
                        setSelectedHeading={setSelectedHeading}
                        setSelectedProductType={setSelectedProductType}
                    />
                )
            })}
            {showModal && <CreateModal
                show={showModal}
                onHide={() => _handleOnHide()}
                submitBtnText={`${additionalProduct.isEdit && !showContactLensModal ? 'Edit Product'
                    : !additionalProduct.isEdit && !showContactLensModal ? 'Add Product'
                        : showContactLensModal ? 'Add Prescription'
                            : ''}`}
                handleSubmit={handleSubmit}
                maxWidth={(showContactLensModal || isValidProductType(selectedProductType) || isValidProductType(additionalProduct?.product_type_name)) ? '1200px' : ''}
            >
                <div className=''>
                    {!showContactLensModal && <div className='row'>
                        <div className={showLensHeading() ? 'col-4' : 'col-6'}>
                            {!additionalProduct?.isEdit &&
                                <div className="form-outline mb-4"
                                // style={{ minWidth: '225px' }}
                                >
                                    <Select
                                        options={productTypeList}
                                        onChange={(obj: any) => _handleSelectedProductType(obj)}
                                        label={"Product Type"} placeholder={'Select'} />
                                </div>}
                            {additionalProduct?.isEdit &&
                                <div className="mb-4 d-flex flex-wrap align-items-center">
                                    <label className='inputs-label mb-2 fs-16 fw-600  secondary-color'>{'Product Type'}</label>
                                    <div className='w-100 ps-2 d-flex align-items-center'
                                        style={{
                                            border: '1px solid #d5d5d5',
                                            backgroundColor: '#f3f3f3',
                                            borderRadius: '5px',
                                            minHeight: '55px',
                                            cursor: 'default'
                                        }}>{additionalProduct?.product_type_name}</div>
                                </div>
                            }
                        </div>
                       {showLensHeading() && <div className='col-4'>
                            <div className="form-outline mb-4">
                                <Select
                                    options={optionForLensHeading()}
                                    onChange={(obj: any) => _handleSelectedHeading(obj)}
                                    label={"Select Lens"} placeholder={'Select Lens'} 
                                    value={selectedHeading}/>
                            </div>
                        </div>}
                        <div className={showLensHeading() ? 'col-4' : 'col-6'}>
                            <div className="form-outline mb-4">
                                <Input type={"number"}
                                    onChange={(e: any) => setAdditionalProduct({ ...additionalProduct, price: e.target.value })}
                                    label={"Amount"} value={additionalProduct?.price} placeholder={'Enter Amount'} />
                            </div>
                        </div>
                    </div>}
                    {!showContactLensModal &&
                        <div>
                            <div className={`form-outline mb-4`}
                            // style={{ maxWidth: '560px' }}
                            >
                                <TextArea type={"text"}
                                    onChange={(e: any) => setAdditionalProduct({ ...additionalProduct, description: e.target.value })}
                                    label={"Description"} value={additionalProduct?.description} placeholder={'Enter Description'} />
                            </div>
                        </div>
                    }
                    {(showContactLensModal || isValidProductType(selectedProductType) || isValidProductType(additionalProduct?.product_type_name)) &&
                        <>


                            <div className='row'>
                                <div className="col-12 col-md-6">
                                    <div className="form-outline mb-4"
                                    // style={{ minWidth: '225px' }}
                                    >
                                        <Input type={"text"}
                                            onChange={(e: any) => setAdditionalProduct({ ...additionalProduct, name: e.target.value })}
                                            label={"Name"} value={additionalProduct?.name} placeholder={'Enter Name'}
                                            errors={!additionalProduct?.name && lensDetailsError && 'This field is required'} />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">

                                    <div className="form-outline mb-4">
                                        <label className='inputs-label mb-2 fs-16 fw-600 secondary-color'>Phone Number</label>
                                        <div style={{ position: "relative" }}>
                                            <Input type={"number"}
                                                onChange={(e: any) => setAdditionalProduct({ ...additionalProduct, phone: e.target.value })}
                                                value={additionalProduct?.phone} placeholder={'Enter Phone Number'}
                                                errors={!additionalProduct?.phone && lensDetailsError && 'This field is required'}
                                            />
                                            {lensPhoneNumberError && additionalProduct?.phone && !(additionalProduct?.phone?.toString()?.length === mobileLenByRegion()) && <span className="error-text">phone number should be {mobileLenByRegion()} digit</span>}
                                            <Button
                                                className={`position-absolute shadow-none border-0 add-product-btn`}
                                                isDisabled={!additionalProduct?.phone}
                                                onClick={() => getLensContactLensDetail(additionalProduct?.phone, selectedProductType)} >
                                                Search
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {showContactLensModal && <div className='row'>
                                <div className="col-6">

                                    <div className="form-outline mb-4"
                                    // style={{ minWidth: '225px' }}
                                    >
                                        <Select
                                            options={eyeTypes}
                                            value={selectedEyeType}
                                            onChange={(obj: any) => _handleSelectedEyeType(obj)}
                                            label={"Select Eye"} placeholder={'Select'}
                                            errors={((!selectedEyeType && eyeTypeError) || (!selectedEyeType && lensDetailsError)) && 'This field is required'}
                                        />
                                    </div>
                                    {/* {additionalProduct?.isEdit &&
                                        <div className="mb-4 d-flex flex-wrap align-items-center">
                                            <label className='inputs-label mb-2 fs-16 fw-600  secondary-color'>{'Product Type'}</label>
                                            <div className='w-100 ps-2 d-flex align-items-center'
                                                style={{
                                                    border: '1px solid #d5d5d5',
                                                    backgroundColor: '#f3f3f3',
                                                    borderRadius: '5px',
                                                    minHeight: '55px',
                                                    cursor: 'default'
                                                }}>{additionalProduct?.product_type_name}</div>
                                        </div>
                                    } */}
                                </div>
                            </div>}

                            {(showContactLensModal && selectedEyeType || !showContactLensModal) &&
                                <div className='row'>
                                    <div className="col-12 ">
                                        <div className='card'>
                                            <div className={`row px-2 my-2 ${(showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE || showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE || showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) && 'd-flex justify-content-center'}`}>
                                                {((showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE) || (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) || !showContactLensModal) &&
                                                    <div className="col-12 col-md-6">
                                                        <h3 className='text-center inputs-label m-2 fs-16 fw-600 secondary-color'>{`${showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE ? 'BOTH EYE (OD)' : 'RIGHT EYE (OD)'}`}</h3>

                                                        <div className="d-flex gap-1">
                                                            <div className="align-items-center d-flex" style={{ width: '225px' }} >
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`DV :`}</h4>
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => {
                                                                        const newValue = e.target.value;
                                                                        if(newValue && !constant.VALID_NUMBER_REGEX.test(newValue)) return;
                                                                        const updatedProduct = { ...additionalProduct };

                                                                        if (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
                                                                            updatedProduct.l_dv_sph = newValue;
                                                                            updatedProduct.l_nv_sph = formatValue(sumTwoNumbers(newValue, parseFloat(additionalProduct.l_add)), newValue);
                                                                        }

                                                                        updatedProduct.r_dv_sph = newValue;
                                                                        updatedProduct.r_nv_sph = formatValue(sumTwoNumbers(newValue, parseFloat(additionalProduct.r_add)), newValue);

                                                                        setAdditionalProduct(updatedProduct);
                                                                    }}
                                                                    label='SPH' value={additionalProduct?.r_dv_sph} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                        const newValue = e.target.value;
                                                                        if(newValue && !constant.VALID_NUMBER_REGEX.test(newValue)) return;

                                                                        const updatedProduct = { ...additionalProduct };

                                                                        if (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
                                                                            updatedProduct.l_dv_cyl = newValue;
                                                                            updatedProduct.l_nv_cyl = newValue;
                                                                        }

                                                                        updatedProduct.r_dv_cyl = newValue;
                                                                        updatedProduct.r_nv_cyl = newValue;

                                                                        setAdditionalProduct(updatedProduct);
                                                                    }}

                                                                    label='CYL' value={additionalProduct?.r_dv_cyl} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => {
                                                                        const newValue = e.target.value;
                                                                        if(newValue && !constant.VALID_NUMBER_REGEX.test(newValue)) return;

                                                                        const updatedProduct = { ...additionalProduct };

                                                                        if (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
                                                                            updatedProduct.l_dv_axis = newValue;
                                                                            updatedProduct.l_nv_axis = newValue;
                                                                        } else {
                                                                            // Ensure left eye retains its original values if the condition is not met
                                                                            updatedProduct.l_dv_axis = additionalProduct.l_dv_axis;
                                                                            updatedProduct.l_nv_axis = additionalProduct.l_nv_axis;
                                                                        }

                                                                        updatedProduct.r_dv_axis = newValue;
                                                                        updatedProduct.r_nv_axis = newValue;

                                                                        setAdditionalProduct(updatedProduct);
                                                                    }}

                                                                    label='AXIS' value={additionalProduct?.r_dv_axis} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => {
                                                                        const newValue = e.target.value;
                                                                        if(newValue && !constant.VALID_NUMBER_REGEX.test(newValue)) return;

                                                                        const updatedProduct = { ...additionalProduct };

                                                                        if (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
                                                                            updatedProduct.l_dv_pd = newValue;
                                                                            updatedProduct.l_nv_pd = newValue;
                                                                        }

                                                                        updatedProduct.r_dv_pd = newValue;
                                                                        updatedProduct.r_nv_pd = newValue;

                                                                        setAdditionalProduct(updatedProduct);
                                                                    }}

                                                                    label='PD' value={additionalProduct?.r_dv_pd} placeholder='' />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex mt-2 gap-1">
                                                            <div className="align-items-center d-flex" style={{ width: '225px' }}>
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`NV :`}</h4>
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''}
                                                                    value={additionalProduct.r_nv_sph}
                                                                    disabled={true} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.r_nv_cyl} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.r_nv_axis} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.r_nv_pd} placeholder='' />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex mt-2">
                                                            <div className=" align-items-center d-flex" style={{ width: '100px' }}>
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`ADD :`}</h4>
                                                            </div>
                                                            <div className="" style={{ width: '110px' }}>
                                                                <Input type='text'
                                                                    onChange={(e: any) => {
                                                                        const newValue = e.target.value;

                                                                        const updatedProduct = { ...additionalProduct };

                                                                        if (showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE) {
                                                                            updatedProduct.l_add = newValue;
                                                                            updatedProduct.l_nv_sph = formatValue(
                                                                                sumTwoNumbers(parseFloat(additionalProduct.l_dv_sph), parseFloat(newValue)),
                                                                                newValue
                                                                            );
                                                                        }

                                                                        updatedProduct.r_add = newValue;
                                                                        updatedProduct.r_nv_sph = formatValue(
                                                                            sumTwoNumbers(parseFloat(additionalProduct.r_dv_sph), parseFloat(newValue)),
                                                                            newValue
                                                                        );

                                                                        setAdditionalProduct(updatedProduct);
                                                                    }}

                                                                    value={additionalProduct?.r_add} placeholder='' />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                {((showContactLensModal && selectedEyeType?.value === constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE) || !showContactLensModal) &&
                                                    <div className={`col-12 col-md-6 mt-4 mt-md-0 ${!showContactLensModal && 'left-border'} `}
                                                    //  style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.175)' }}
                                                    >
                                                        {(!showContactLensModal) && <hr className='d-block d-md-none' />}

                                                        <h3 className='text-center inputs-label my-2 fs-16 fw-600 secondary-color'>{`LEFT EYE (OS)`}</h3>
                                                        <div className="d-flex gap-1">
                                                            <div className="align-items-center d-flex" style={{ width: '225px' }} >
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`DV :`}</h4>
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => (!e.target.value || constant.VALID_NUMBER_REGEX.test(e.target.value)) &&
                                                                        setAdditionalProduct({ 
                                                                            ...additionalProduct,
                                                                            l_dv_sph: e.target.value, 
                                                                            l_nv_sph: formatValue(sumTwoNumbers(e.target.value, parseFloat(additionalProduct.l_add)), e.target.value) })}
                                                                    label='SPH' value={additionalProduct?.l_dv_sph} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => (!e.target.value || constant.VALID_NUMBER_REGEX.test(e.target.value)) && setAdditionalProduct({ ...additionalProduct, l_dv_cyl: e.target.value, l_nv_cyl: e.target.value })}
                                                                    label='CYL' value={additionalProduct?.l_dv_cyl} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => (!e.target.value || constant.VALID_NUMBER_REGEX.test(e.target.value)) && setAdditionalProduct({ ...additionalProduct, l_dv_axis: e.target.value, l_nv_axis: e.target.value })}
                                                                    label='AXIS' value={additionalProduct?.l_dv_axis} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) =>(!e.target.value || constant.VALID_NUMBER_REGEX.test(e.target.value)) && setAdditionalProduct({ ...additionalProduct, l_dv_pd: e.target.value, l_nv_pd: e.target.value })}
                                                                    label='PD' value={additionalProduct?.l_dv_pd} placeholder='' />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex mt-2 gap-1">
                                                            <div className=" align-items-center d-flex" style={{ width: '225px' }} >
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`NV :`}</h4>
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''}
                                                                    value={additionalProduct.l_nv_sph}
                                                                    disabled={true} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.l_nv_cyl} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.l_nv_axis} placeholder='' />
                                                            </div>
                                                            <div className="">
                                                                <Input type='text'
                                                                    onChange={(e: any) => ''} disabled={true}
                                                                    value={additionalProduct?.l_nv_pd} placeholder='' />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex mt-2">
                                                            <div className="align-items-center d-flex" style={{ width: '100px' }} >
                                                                <h4 className='fs-16 fw-600 secondary-color'>{`ADD :`}</h4>
                                                            </div>
                                                            <div className="" style={{ width: '110px' }}>
                                                                <Input type='text'
                                                                    onChange={(e: any) => setAdditionalProduct({ ...additionalProduct, l_add: e.target.value, l_nv_sph: formatValue(sumTwoNumbers(parseFloat(additionalProduct.l_dv_sph), e.target.value), e.target.value) })}
                                                                    value={additionalProduct?.l_add} placeholder='' />
                                                            </div>
                                                        </div>

                                                    </div>}
                                                <div className="d-flex justify-content-end">

                                                    {selectedEyeType && <div className="" >
                                                        <Button
                                                            isDisabled={!selectedEyeType}
                                                            className={`shadow-none border-0 add-product-btn`}
                                                            onClick={() =>
                                                                clearEyeDetail()
                                                            }
                                                        >Clear All</Button>
                                                    </div>}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>}
                        </>

                    }
                </div>
            </CreateModal>}
        </div >
    )
}

export default Index